exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css"), undefined);

// module
exports.push([module.id, "._2u0NKWFUVO10_7zl5FH1bX {\n    margin-top: 16px;\n    margin-top: 1rem;\n    margin-left: 32px;\n    margin-left: 2rem;\n    width: calc(100% - 2rem);\n}\n\n._14Noc9w-o_IUonJxsVOnBQ {\n    text-align: left;\n    font-size: 17.6px;\n    font-size: 1.1rem;\n    border-bottom: 1px solid #d9d9d9;\n}\n\n._3qzzdu41HzTOjXefzRE8dy {\n}\n\n._3g8_wlJYIQqfvRx4Tdzt4u {\n    width: 100%;\n}\n\n._1XONXofpDzZZq1kxZDtU2p {\n}\n\n.Sb22PNqbe2ZV1oFtChBAD {\n}\n", ""]);

// exports
exports.locals = {
	"table": "_2u0NKWFUVO10_7zl5FH1bX",
	"header": "_14Noc9w-o_IUonJxsVOnBQ",
	"key": "_3qzzdu41HzTOjXefzRE8dy " + require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css").locals["argumentCell"] + "",
	"value": "_3g8_wlJYIQqfvRx4Tdzt4u",
	"row": "_1XONXofpDzZZq1kxZDtU2p " + require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css").locals["argumentRow"] + "",
	"argumentName": "Sb22PNqbe2ZV1oFtChBAD " + require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css").locals["argumentName"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/FieldArgumentsTableView.css
 ** module id = 22
 ** module chunks = 0
 **/